import React from 'react';
import Button from '@/components/Button';
import ExternalLink from '@/components/ExternalLink';
import Icon from '@/components/Icon';
import avaImage from 'images/ava-transparente-cabeca.png';
import { avaCheckoutPath, settingsManageCurrentPlanPath } from '@/routes';

function AvaAddonsCard({ isPaid }) {
  return (
    <div className='d-flex justify-content-between align-items-center py-5'>
      <div className='d-flex'>
        <div className='d-inline-block p-1 me-2'>
          <div
            className='p-1 rounded bg-primary bg-opacity-10 text-dark-gray lh-0 position-relative'
          >
            <img
              src={avaImage}
              className='icon icon-md'
              alt='Avatar'
              style={{
                objectFit: 'cover',
                maxWidth: '100%',
                maxHeight: '100%'
              }}
            />
          </div>
        </div>
        <div>
          <h5>Ava - Assistente Virtual no WhatsApp</h5>
          <span className='text-small text-medium-gray'>
            Atualize seu CRM sem sair do WhatsApp, a qualquer hora, e
            <br />receba sugestões de ações de vendas da nossa IA.
          </span>
        </div>
      </div>
      <div className='d-flex flex-column align-items-end'>
        {isPaid && (
          <Button
            variant='light-primary'
            size='sm'
            className='mb-1 width-4 text-primary'
            href={settingsManageCurrentPlanPath()}
            state={{ target: { type: 'ava' } }}
          >
            Gerenciar
          </Button>
        )}
        {!isPaid && (
          <Button
            variant='light-primary'
            size='sm'
            className='mb-1 width-4 text-primary'
            target={'_blank'}
            href={avaCheckoutPath()}
          >
            Adquirir Ava
          </Button>
        )}
        <Button
          variant='outline-primary'
          size='sm'
          className='width-4'
          as={ExternalLink}
          target={'_blank'}
          href='https://www.agendor.com.br/solucoes/ava'
        >
          <Icon name='external-link' size='sm' className='me-1' />
          Saiba mais
        </Button>
      </div>
    </div >
  );
}

export default AvaAddonsCard;
